// Test IDs for the EMDpay landing page.

export const HOME = {
        emergentLink: 'home-emergent-link',
};

export const LANDING = {
        // Header
        headerLogo: 'landing-header-logo',
        headerNavFeatures: 'landing-header-nav-features',
        headerNavEducation: 'landing-header-nav-education',
        headerNavProfessional: 'landing-header-nav-professional',
        headerNavCards: 'landing-header-nav-cards',
        headerNavFaq: 'landing-header-nav-faq',
        headerCtaInstall: 'landing-header-cta-install',
        headerMobileMenuToggle: 'landing-header-mobile-menu-toggle',

        // Hero
        heroInstallCta: 'landing-hero-install-cta',
        heroSecondaryCta: 'landing-hero-secondary-cta',
        heroPhoneMockup: 'landing-hero-phone-mockup',

        // How it works
        howItWorks: 'landing-how-it-works',

        // Education
        educationSection: 'landing-education-section',
        educationCard: 'landing-education-card',

        // Professional
        professionalSection: 'landing-professional-section',
        professionalCard: 'landing-professional-card',

        // Card discovery
        cardDiscoverySection: 'landing-card-discovery-section',

        // Travel
        travelSection: 'landing-travel-section',

        // Security
        securitySection: 'landing-security-section',
        trustBadgePci: 'landing-trust-badge-pci',
        trustBadgeRbi: 'landing-trust-badge-rbi',
        trustBadgeEncryption: 'landing-trust-badge-encryption',

        // Stats
        statsSection: 'landing-stats-section',

        // Testimonials
        testimonialsSection: 'landing-testimonials-section',

        // FAQ
        faqSection: 'landing-faq-section',
        faqItem: 'landing-faq-item',

        // Final CTA
        finalCtaInstall: 'landing-final-cta-install',

        // Footer
        footer: 'landing-footer',
        footerEmail: 'landing-footer-email',
};
